export default __webpack_public_path__ + "static/media/mk.128d6f49.svg";